let currentID = 0;

export default (prefix = ''): string => {
  currentID = currentID + 1;
  return `${prefix}ID__${currentID}`;
};
